<template>
  <section class="pages-overview">
    <div v-if="!showEditCard && !loadingPages">
      <div class="grid-container grid-col-3">
        <div
          class="page-container"
          v-for="(page, index) in hotelPages"
          :key="index"
        >
          <div class="page-container__action-buttons-container">
            <div class="fab-button" @click="showFAB(index)">
              <v-icon class="fab-button__icon" name="chevron-down"></v-icon>
            </div>
            <div
              class="page-container__action-buttons-container__dropdown"
              v-show="activeFABIndex === index && optionsActive"
            >
              <div
                class="fab-button"
                @click="toggleShow(page['.key'], page.name, page.path)"
              >
                <v-icon class="fab-button__icon" name="pencil-alt"></v-icon>
              </div>
              <div
                class="fab-button"
                @click="copyPage(page['.key'], page.name)"
              >
                <v-icon class="fab-button__icon" name="clone"></v-icon>
              </div>
              <div
                class="fab-button"
                @click="
                  (deleteModalVisible = true), (pageToRemove = page['.key'])
                "
              >
                <v-icon
                  class="fab-button__icon"
                  name="regular/trash-alt"
                ></v-icon>
              </div>
            </div>
          </div>
          <div class="page-container__name-container">
            <div class="file-icon">
              <v-icon name="regular/file" scale="10"></v-icon>
            </div>
            <p class="h2 add--text-align-center">{{ page.name }}</p>
          </div>
        </div>
      </div>

      <!-- <div v-for="(page, key) in hotelPages" :key="key" class="pageOuterWrap">
        <div class="pageTitleWrap">
        <p> {{page.name}} </p>
        </div>
        <div class="btnWrap">
        <button-global type="negative" text="DELETE" size="small" @eventPassed="deleteModalVisible = true, pageToRemove = page['.key']" ></button-global>
        <button-global type="neutral" text="COPY" size="small" @eventPassed="copyPage(page['.key'], page.name)"></button-global>
        <button-global type="positive" text="EDIT" size="small" @eventPassed="toggleShow(page['.key'], page.name, page.path)" ></button-global>
        </div>
      </div> -->
    </div>
    <fetching-loader
      displayType="displayBlock"
      v-if="loadingPages"
    ></fetching-loader>
    <edit-guestbook-pages
      v-if="showEditCard"
      :pageSelected="pageSelection"
      :pageName="editPageName"
      :pagePath="pagePath"
    ></edit-guestbook-pages>
    <confirm-modal
      v-if="deleteModalVisible"
      @yes="closeWithYes()"
      @no="closeWithNo()"
    >
      <h2 slot="title">Delete Page?</h2>
      <p slot="description">The page and its content will be deleted</p>
    </confirm-modal>
  </section>
</template>

<script>
import ConfirmModal from "@/components/GlobalComponents/ConfirmModal";
import EditGuestbookPages from "./PagesEditExisitng";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import bus from "@/bus.js";
import { db } from "@/firebase";

export default {
  components: {
    ConfirmModal,
    // ButtonGlobal,
    EditGuestbookPages,
    FetchingLoader,
  },
  data() {
    return {
      deleteModalVisible: false,
      pageToRemove: "",
      pageName: "",
      showEditCard: false,
      pageSelection: "",
      editPageName: "",
      pagePath: "",
      loadingPages: true,

      activeFABIndex: null,
      optionsActive: false,
    };
  },
  firebase() {
    return {
      hotelPages: {
        source: db
          .ref(`/pages/${this.$customerId}/${this.$hotelId}/overview`)
          .orderByChild("timestamp"),
        readyCallback: function () {
          this.loadingPages = false;
        },
      },
    };
  }, //end of Firebase
  created() {
    bus.$on("closeSelectedPage", () => {
      this.pageSelection = "";
      this.showEditCard = false;
    });
  },
  methods: {
    showFAB(index) {
      if (index === this.activeFABIndex) {
        // If same as active, toggle
        this.optionsActive = !this.optionsActive;
      } else {
        // If not same as active, set true
        this.optionsActive = true;
      }
      this.activeFABIndex = index;
    },
    closeWithYes: function () {
      this.deleteModalVisible = false;
      this.deletePage(this.pageToRemove);
      this.pageToRemove = "";
    },
    closeWithNo: function () {
      this.deleteModalVisible = false;
      this.pageToRemove = "";
    },
    closeReturn() {
      this.$router.push({ name: "guestbook" });
    },
    copyPage(existingPageKey, exisitingPageName) {
      let newKey = db.ref(`/pages/${this.$customerId}/${this.$hotelId}/overview/`).push().key;
      let newPageObj = {
        name: exisitingPageName + " (Copy)",
        path: "/pages/" + this.$hotelId + "/" + newKey,
        timestamp: new Date().getTime(),
      };
      db.ref(`/pages/${this.$customerId}/${this.$hotelId}/${existingPageKey}`)
        .once("value")
        .then((snapshot) => {
          let batchUpdate = {};
          batchUpdate[`/${newKey}`] = snapshot.val();
          batchUpdate[`/overview/${newKey}`] = newPageObj;
          return db.ref(`/pages/${this.$customerId}/${this.$hotelId}`).update(batchUpdate);
        })
        .then(() => {
          this.$toastEvents.push({
            type: "copy",
            title: "Pages",
            content: "Page has been copied",
            id: +new Date(),
          });
        });
    },
    deletePage(key) {
      var removeLink = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/overview/`)
        .child(key)
        .remove();
      var removePageContent = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/`)
        .child(key)
        .remove();
      Promise.all([removeLink, removePageContent]).then(() =>
        this.$toastEvents.push({
          type: "copy",
          title: "Deletion",
          content: "The page has been deleted",
          id: +new Date(),
        })
      );
    },
    toggleShow(key, name, pathToPage) {
      this.pageSelection = key;
      this.editPageName = name;
      this.pagePath = pathToPage;
      this.showEditCard = !this.showEditCard;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-container {
  border: 2px solid var(--grey-light);
  position: relative;
  height: 200px;
  max-width: 396px;
  border-radius: var(--border-radius);
}

.fab-button {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
  border-radius: 50%;
  color: var(--light);
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
  transition: var(--transition);
  user-select: none;
  z-index: 5;
}

.fab-button:hover {
  background-color: var(--primary-hover);
}

.page-container__action-buttons-container__dropdown .fab-button:nth-child(1) {
  top: 43px;
}

.page-container__action-buttons-container__dropdown .fab-button:nth-child(2) {
  top: 91px;
}

.page-container__action-buttons-container__dropdown .fab-button:nth-child(3) {
  top: 139px;
}

.page-container__name-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.page-container__name-container p {
  width: 300px;
}

.file-icon {
  position: absolute;
  color: var(--grey-light);
}

.page-container__name-container p {
  z-index: 3;
  word-wrap: break-word;
}

.pageOuterWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #707070;
  background-color: #ffffff;
  padding: 7px;
  margin: 10px;
  height: 80px;
}
.pageTitleWrap {
  display: flex;
}
.pageTitleWrap > img {
  height: 50px;
}
.pageTitleWrap > p {
  margin-left: 20px;
}
.btnWrap {
  display: flex;
}
.btnWrap > div {
  margin-right: 10px;
}
@media (max-width: 760px) {
  .contentCard {
    width: 100%;
    padding-right: 0px;
  }
  .pageOuterWrap {
    flex-direction: column;
    height: auto;
  }
  .buttonAddContainer {
    margin: 0;
    margin-bottom: 20px;
  }
  .buttonAddContainer > input {
    width: 200px;
  }
}
@media (min-width: 1439px) {
  .contentCard {
    width: 80vw;
  }
}
</style>
